import React, { useState } from "react";
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Row } from "reactstrap";
import styled from "styled-components";
import PropTypes from "prop-types";
import CustomSelect from "../../../../components/Common/CustomSelect";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { getDefaultValueForSelect } from "../../../../helpers/utils";

const CampaignParamsBlock = (props) => {
  const {
    data,
    campaignId,
    campaignData,
    updateCampaignProfile,
    //clientData,
    appData,
    offerTypeData,
    sourceData,
    directionTypeData,
    statusData,
    mediaBuyerData,
    formatData,
    history,
    permissions,
  } = props;

  const [isFormSubmit, setIsFormSubmit] = useState(false);

  // const geClients = item => {
  //   let client = [];
  //   item?.map(i => {
  //     client.push({ label: i.legal_name, value: i.id });
  //   });
  //   return client;
  // };

  const getOfferTypes = item => {
    let offer = [];
    item?.map(i => {
      offer.push({ label: i.name, value: i.id });
    });
    return offer;
  };

  const getDirectionTypes = item => {
    let direction = [];
    item?.map(i => {
      direction.push({ label: i.name, value: i.id });
    });
    return direction;
  };

  const getMediaBuyers = item => {
    let media = [];
    item?.map(i => {
      media.push({ label: i.number, value: i.id });
    });
    return media;
  };

  const getApps = item => {
    let app = [];
    item?.map(i => {
      app.push({ label: i.name, value: i.id });
    });
    return app;
  };

  const getSource = item => {
    let source = [];
    item?.map(i => {
      source.push({ label: i.name, value: i.id });
    });
    return source;
  };

  const getStatus = item => {
    let status = [];
    item?.map(i => {
      status.push({ label: i.name, value: i.id });
    });
    return status;
  };

  const getFormat = item => {
    let format = [];
    item?.map(i => {
      format.push({ label: i.name, value: i.id });
    });
    return format;
  };

  const onSubmitForm = (e, errors, params) => {
    setIsFormSubmit(true);
    let profile = {
      campaignId: data.campaign_id,
      campaignName: data.campaign_name,
      platform: data.platform,
      accountName: params.accountName.value,
      campaignFormat: params.campaignFormat.value,
      campaignStatus: params.campaignStatus.value,
      //client: params.client.value,
      clientApp: params.clientApp.value,
      directionType: params.directionType.value,
      mediaBuyer: params.mediaBuyer.value,
      offerType: params.offerType.value,
      source: params.source.value
    };
    updateCampaignProfile(campaignId, profile, campaignData);
    history.push(`/campaigns`);
  };

  return (
    <Row>
      <Col lg={12}>


        <AvForm className="needs-validation" onSubmit={onSubmitForm}>
          <Card>
            <CardBody>
              <CardTitle className="h4">Campaign params</CardTitle>
              <Row className="mt-2">
                <Col lg={6}>
                  {/*<div className="mt-4">*/}
                  {/*  <div className="mb-3 select2-container">*/}
                  {/*    <label htmlFor="client" className="form-label">Clients</label>*/}
                  {/*    <FormGroup>*/}
                  {/*      <CustomSelect*/}
                  {/*        name="client"*/}
                  {/*        defaultValue={getDefaultValueForSelect(data?.client)}*/}
                  {/*        options={geClients(clientData)}*/}
                  {/*        placeholder="Select client..."*/}
                  {/*        classNamePrefix="select2-selection"*/}
                  {/*        //errorMessage="Client field is required"*/}
                  {/*        //onChange={setClientSelect}*/}
                  {/*        //required*/}
                  {/*        isFormSubmit={isFormSubmit}*/}
                  {/*      />*/}
                  {/*    </FormGroup>*/}
                  {/*  </div>*/}
                  {/*</div>*/}
                  <div className="mt-4">
                    <div className="mb-3 select2-container">
                      <label htmlFor="offerType" className="form-label">Offer type</label>
                      <FormGroup>
                        <CustomSelect
                          name="offerType"
                          defaultValue={getDefaultValueForSelect(data?.offer_type)}
                          options={getOfferTypes(offerTypeData)}
                          placeholder="Select offer type..."
                          classNamePrefix="select2-selection"
                          //errorMessage="Offer type field is required"
                          //onChange={setClientSelect}
                          //required
                          isFormSubmit={isFormSubmit}
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <div className="mt-4">
                    <div className="mb-3 select2-container">
                      <label htmlFor="directionType" className="form-label">Direction type</label>
                      <FormGroup>
                        <CustomSelect
                          name="directionType"
                          defaultValue={getDefaultValueForSelect(data?.direction_type)}
                          options={getDirectionTypes(directionTypeData)}
                          placeholder="Select direction type..."
                          classNamePrefix="select2-selection"
                          //errorMessage="Offer type field is required"
                          //onChange={setClientSelect}
                          //required
                          isFormSubmit={isFormSubmit}
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <div className="mt-4">
                    <div className="mb-3 select2-container">
                      <label htmlFor="mediaBuyer" className="form-label">Media buyer</label>
                      <FormGroup>
                        <CustomSelect
                          name="mediaBuyer"
                          defaultValue={getDefaultValueForSelect(data?.media_buyer)}
                          options={getMediaBuyers(mediaBuyerData)}
                          placeholder="Select media buyer..."
                          classNamePrefix="select2-selection"
                          //errorMessage="Offer type field is required"
                          //onChange={setClientSelect}
                          //required
                          isFormSubmit={isFormSubmit}
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <div className="mt-4">
                    <label htmlFor="accountName" className="form-label">Account name (in platform)</label>
                    <AvField
                      name="accountName"
                      value={data?.account_name ? data?.account_name : ""}
                      type="text"
                      //errorMessage="Invalid budget"
                      // validate={{
                      //   required: { value: false },
                      //   minLength: { value: 1, errorMessage: "Min 1 number" },
                      // }}
                      // value={this.state.orders.billingName || ""}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mt-4">
                    <label htmlFor="clientApp" className="form-label">Client&apos;s application</label>
                    <FormGroup>
                      <CustomSelect
                        name="clientApp"
                        defaultValue={getDefaultValueForSelect(data?.application)}
                        options={getApps(appData)}
                        placeholder="Select application..."
                        classNamePrefix="select2-selection"
                        //errorMessage="Offer type field is required"
                        //onChange={setClientSelect}
                        //required
                        isFormSubmit={isFormSubmit}
                      />
                    </FormGroup>
                  </div>
                  <div className="mt-4">
                    <label htmlFor="source" className="form-label">Source</label>
                    <FormGroup>
                      <CustomSelect
                        name="source"
                        defaultValue={getDefaultValueForSelect(data?.source)}
                        options={getSource(sourceData)}
                        placeholder="Select source..."
                        classNamePrefix="select2-selection"
                        //errorMessage="Offer type field is required"
                        //onChange={setClientSelect}
                        //required
                        isFormSubmit={isFormSubmit}
                      />
                    </FormGroup>
                  </div>
                  <div className="mt-4">
                    <label htmlFor="campaignStatus" className="form-label">Campaign status</label>
                    <FormGroup>
                      <CustomSelect
                        name="campaignStatus"
                        defaultValue={getDefaultValueForSelect(data?.status)}
                        options={getStatus(statusData)}
                        placeholder="Select status..."
                        classNamePrefix="select2-selection"
                        //errorMessage="Offer type field is required"
                        //onChange={setClientSelect}
                        //required
                        isFormSubmit={isFormSubmit}
                      />
                    </FormGroup>
                  </div>
                  <div className="mt-4">
                    <label htmlFor="campaignFormat" className="form-label">Campaign format</label>
                    <FormGroup>
                      <CustomSelect
                        name="campaignFormat"
                        defaultValue={getDefaultValueForSelect(data?.format)}
                        options={getFormat(formatData)}
                        placeholder="Select format..."
                        classNamePrefix="select2-selection"
                        //errorMessage="Offer type field is required"
                        //onChange={setClientSelect}
                        //required
                        isFormSubmit={isFormSubmit}
                      />
                    </FormGroup>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card className="bg-transparent shadow-none">
            <div className="text-end">
              {permissions["change_campaignmodel"] && <button type="submit" className="btn btn-primary">
                Save changes
              </button>}
            </div>
          </Card>
        </AvForm>
      </Col>
    </Row>
  )
    ;
};

CampaignParamsBlock.propTypes = {
  data: PropTypes.any,
  campaignId: PropTypes.any,
  campaignData: PropTypes.any,
  updateCampaignProfile: PropTypes.func,
  //clientData: PropTypes.any,
  appData: PropTypes.any,
  offerTypeData: PropTypes.any,
  sourceData: PropTypes.any,
  directionTypeData: PropTypes.any,
  statusData: PropTypes.any,
  mediaBuyerData: PropTypes.any,
  formatData: PropTypes.any,
  history: PropTypes.any,
  permissions: PropTypes.any,
};

const ButtonContainer = styled.div`
  padding-top: 30px;
  text-align: right !important;
`;

export default CampaignParamsBlock;
